import App from './en/views/App'
import Home from './en/views/Home'
import ModelReport from './en/views/ModelReport'
import planOptimizer from './en/views/planOptimizer'
import planSimulator from './en/views/planSimulator'
import SimulationDetails from './en/views/SimulationDetails'
import Documents from './en/views/Documents'
import WhatIfScenario from './en/views/WhatIfScenario'
import BudgetSimulator from './en/views/BudgetSimulator'
import BudgetSimulationDetails from './en/views/BudgetSimulationDetails'
import adminUsers from './en/views/adminUsers'
import adminClients from './en/views/adminClients'
import adminReferenceModels from './en/views/adminReferenceModels'
import adminAdHocModels from './en/views/adminAdHocModels'
import manageCustomModels from './en/views/manageCustomModels'
import manageEkrm from './en/views/manageEkrm'
import modelComposer from './en/views/modelComposer'
import automaticModels from './en/views/automaticModels'
import manageUserModels from './en/views/manageUserModels'
import learningCenter from './en/views/learningCenter'
import stats from './en/views/stats'
import adminTools from './en/views/adminTools'
import adminPendingPlans from './en/views/adminPendingPlans'
import adminAIReviews from './en/views/adminAIReviews'
import adminErrorLogs from './en/views/adminErrorLogs'
import adminNews from './en/views/adminNews'
import adminCountries from './en/views/adminCountries'
import InsertMap from './en/views/InsertMap'
import playground from './en/views/playground'
import DataUpload from './en/views/DataUpload'
import DataCheck from './en/views/DataCheck'
import ModelingProcess from './en/views/ModelingProcess'
import SharedPlan from './en/views/SharedPlan'
import SharedModelReport from './en/views/SharedModelReport'
import ExportData from './en/views/ExportData'

// Components translations
import components from './en/components/index'
import AI from './en/components/AI'
import ekrm from './en/components/ekrm'
import simulationDetails from './en/components/simulationDetails'
import budgetSimulator from './en/components/budgetSimulator'
import userData from './en/components/userData'
import dataCheck from './en/components/dataCheck'

export default {
  views: {
    App,
    Home,
    ModelReport,
    planOptimizer,
    BudgetSimulator,
    BudgetSimulationDetails,
    planSimulator,
    SimulationDetails,
    Documents,
    WhatIfScenario,
    adminUsers,
    adminClients,
    adminReferenceModels,
    adminAdHocModels,
    manageCustomModels,
    manageEkrm,
    modelComposer,
    automaticModels,
    manageUserModels,
    learningCenter,
    stats,
    adminTools,
    adminPendingPlans,
    adminAIReviews,
    adminErrorLogs,
    adminNews,
    adminCountries,
    InsertMap,
    playground,
    DataUpload,
    DataCheck,
    ModelingProcess,
    SharedPlan,
    SharedModelReport,
    ExportData
  },
  components: {
    ...components,
    AI,
    ekrm,
    simulationDetails,
    budgetSimulator,
    userData,
    dataCheck
  }
}
